module.exports = __webpack_public_path__ + "assets/img/TrendingNow_IA2.c2febed9-ps.jpg";